export default __webpack_public_path__ + "static/media/step_B_EN.5caa698d.png";